<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información del Vendedor">
          <b-table 
              class="registro datos-objeto"
              responsive="sm" 
              :items="vendedorDatos" 
              :fields="campos">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Clientes">
          <b-table 
              class="registro"
              responsive="sm" 
              :items="vendedorClientesDatos" 
              :fields="clientesFields">
            <template v-slot:cell(pjeComision)="data">
              <template v-if="(data.item.tipoComision == 1 || data.item.tipoComision == 3) && data.item.tipoPjeComision == 1">
                {{ data.item.pjeComision | numero(2) }}
              </template>
              <template v-else>
                --.--
              </template>
            </template>
            <template v-slot:cell(pjeFeeComision)="data">
              <template v-if="(data.item.tipoComision == 1 || data.item.tipoComision == 3) && data.item.tipoPjeComision == 2">
                {{ data.item.pjeFeeComision | numero(2) }}
              </template>
              <template v-else>
                --.--
              </template>
            </template>
            <template v-slot:cell(importeComision)="data">
              <template v-if="data.item.tipoComision == 2 || data.item.tipoComision == 3">
                {{ data.item.importeComision | moneda }}
              </template>
              <template v-else>
                --.--
              </template>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Proveedores">
          <b-table 
              class="registro"
              responsive="sm" 
              :items="vendedorProveedoresDatos" 
              :fields="proveedoresFields">
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="editar">
            <i class="fa fa-edit"></i>Editar Datos del Vendedor</b-dropdown-item>
          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>      
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'vendedor/getField',
  mutationType: 'vendedor/updateField',
});

export default {
  name: 'VendedorDatos',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal,
  ],
  data: () => {
    return {
      id: 0,
      campos: [
        {key: 'campo'},
        {key: 'valor'},
      ],
      clientesFields: [
        {
          key: 'cliente',
        },
        {
          key: 'clienteContacto',
          label: 'Contacto'
        },
        {
          key: 'tipoComisionNombre',
          label: 'Tipo Comisión'
        },
        {
          key: 'pjeComision',
          class: "text-right"
        },
        {
          key: 'pjeFeeComision',
          label: 'Pje. Fee Comision',
          class: "text-right"
        },
        {
          key: 'importeComision',
          label: 'Importe Comision',
          class: "text-right"
        }
      ],
      proveedoresFields: [
        {
          key: 'proveedor',
        },
      ],
      tableBusy: false,
    }
  },
  created() {
    this.id= this.$route.params.id

    this.tableBusy = true;
    this.$store.dispatch('vendedor/getDatos', this.id)
      .then(() => this.tableBusy = false)
      .catch(error => this.showErrorMsj(error));
  },  
  computed: {
    ...mapFields([
      'vendedorDatos',
      'vendedorClientesDatos',
      'vendedorProveedoresDatos'
    ]),
  },  
  methods: {
    goBack() {
      this.$router.push({ name: 'Vendedores' });
    },
    editar() {
      this.$router.push({ name: 'VendedorEdit', 
                          params: { id: this.id }});
    },
  }
}
</script>
